var map = {
	"./calculator.png": "f31d",
	"./computer.png": "63e0",
	"./discord.png": "7322",
	"./edge.png": "5019",
	"./explorer.png": "5271",
	"./github.png": "44dc",
	"./mail.png": "d557",
	"./notepad.png": "7a3c",
	"./onenote.png": "cbcb",
	"./photos.png": "509c",
	"./powerpoint.png": "d8cc",
	"./search-dark.png": "692a",
	"./search-light.png": "64f4",
	"./settings.png": "704c",
	"./spotify.png": "d32e",
	"./start.png": "a837",
	"./store-dark.png": "8649",
	"./store-light.png": "24cd",
	"./terminal.png": "7c4a",
	"./todo.png": "fb6e",
	"./trash-empty.png": "4167",
	"./trash-full.png": "ba87",
	"./vscode.png": "ceef",
	"./widget.png": "5d7c",
	"./word.png": "b359",
	"./your-phone.png": "d5bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";